import { FormattedMessage, defineMessages, injectIntl } from 'react-intl';

import Header from '../Header';
import { Helmet } from 'react-helmet';
import Panel from '../../container/Panel';
import PropTypes from 'prop-types';
import React from 'react';
import { pure } from 'recompose';
import Footer from "../Footer";

const messages = defineMessages({
  htmlHeader: {
    id: 'unknown-error.html.header',
    description:
      'The title of the page that appears in the html header of the page.',
    defaultMessage: 'Unknown Error'
  },
  headerTitle: {
    id: 'unknown-error.header.title',
    description: 'Page Header Title',
    defaultMessage: 'Unknown Error'
  },
  headerSubTitle: {
    id: 'unknown-error.header.subtitle',
    description: 'Page Header Subtitle',
    defaultMessage: 'There was an unknown error.'
  }
});

const UnknownError = ({ intl, locale, location }) => (
  <div className="unknown-error page">
    <Helmet>
      <title>{intl.formatMessage(messages.htmlHeader)} - Shift</title>
    </Helmet>
    <Header
      title={intl.formatMessage(messages.headerTitle)}
      subtitle={intl.formatMessage(messages.headerSubTitle)}
      icon="engagement"
      locale={locale}
    />
    <div className="main">
      <div className="panels">
        <Panel
          header={
            <h3>
              <FormattedMessage
                id="unknown-error.panel.title"
                defaultMessage="Unknown Error"
              />
            </h3>
          }
        >
          <p>
            <FormattedMessage
              id="unknown-error.panel.paragraph.1"
              defaultMessage="There has been an unknown error in the client that has prevent normal functionality."
            />
          </p>
          <p>
            <FormattedMessage
              id="unknown-error.panel.paragraph.2"
              defaultMessage="Please try refreshing your browser, and if the error continues contact your administrator"
            />
          </p>
        </Panel>
      </div>
    </div>
    <Footer />
  </div>
);

UnknownError.propTypes = {
  intl: PropTypes.object,
  locale: PropTypes.object,
  location: PropTypes.object
};

export default pure(injectIntl(UnknownError));



// WEBPACK FOOTER //
// ./src/components/views/UnknownError/index.js